<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
import { loadSentenceFromId } from './components/editor/rich-text-editor/english-parse'

export default {
  name: 'App',
  data() {
    return {
      routeWatcher: null
    }
  },
  mounted() {
    // 初始检查URL参数
    this.checkSentenceId()
    
    // 监听路由变化，以便在路由切换时检查sentence_id参数
    this.routeWatcher = this.$watch(
      () => this.$route.query,
      () => {
        this.checkSentenceId()
      }
    )
  },
  beforeDestroy() {
    // 清除路由监听
    if (this.routeWatcher) {
      this.routeWatcher()
    }
  },
  methods: {
    checkSentenceId() {
      // 获取sentence_id参数
      const sentenceId = this.$route.query.sentence_id
      
      // 如果存在sentence_id参数，则加载句子数据
      if (sentenceId) {
        console.log('检测到sentence_id参数:', sentenceId)
        // 延迟加载，确保页面已经完全渲染
        setTimeout(() => {
          loadSentenceFromId(sentenceId)
        }, 500)
      }
    }
  }
}
</script>
<style>
* {
  margin: 0;
  padding: 0;
}
</style>
